import { makeRequest } from 'utils/requestLogger';

export default (courseID) => makeRequest('delete', `/api/courses/${courseID}`);



// WEBPACK FOOTER //
// ./src/app/services/courses/deleteCourse.js